import { Component, h, Host, Prop } from "@stencil/core";

@Component({
    tag: "ux-iws-sf-page-body",
    styleUrl: "sf-page-body.scss",
    shadow: false,
})
export class SfPageBody {
    /**
     * Indicates if the body should have no padding.
     */
    @Prop({ reflect: true }) noPadding: boolean = false;

    render() {
        return (
            <Host>
                <slot />
            </Host>
        );
    }
}
